import { TFunction } from 'react-i18next';

import { RootDispatch } from 'storage/store';
import { API } from 'utils';
import { ResponseData } from 'utils/Api/Api.model';

import {
  ContractDetails,
  ContractPaymentsHistoryDTO,
  Contracts,
  ContractPaymentDetails
} from './contracts.model';
import {
  mapContractToAgreement,
  mapNewDetailsToDeprecated,
  mapPaymentsDetails
} from './contracts.mapper';
import {
  Agreement,
  IHistoryData,
  PaymentDetails
} from '../agreements/agreements.model';

const mapContractPaymentsHistoryToHistoryData = (
  dto: ContractPaymentsHistoryDTO,
  index: number
): IHistoryData => ({
  uniqueId: index,
  date: dto.date,
  payer: dto.payer,
  amount: dto.amount.amount,
  currency: dto.amount.currency,
  status: dto.status
});

const endpoint = '/contracts';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const effects = (dispatch: RootDispatch) => ({
  async getContractHistoryPayments({
    contractId,
    sourceContractId
  }: {
    contractId: number;
    sourceContractId: number;
  }): Promise<IHistoryData[]> {
    const result = await API.get<
      undefined,
      ResponseData<ContractPaymentsHistoryDTO[]>
    >(`${endpoint}/${contractId}/payments`)
      .then((response) => {
        const mappedPayments = response.data.map(
          mapContractPaymentsHistoryToHistoryData
        );
        dispatch.contractsAgreements.storeAgreementPayments(
          mappedPayments,
          sourceContractId
        );
        return mappedPayments;
      })
      .catch((error) => error);
    return result;
  },
  async getContractById({
    contractId,
    agreementId,
    t
  }: {
    contractId: number;
    agreementId: number;
    t: TFunction<'translation'>;
  }): Promise<Agreement | undefined> {
    return API.get<undefined, ResponseData<ContractDetails>>(
      `${endpoint}/${contractId}`
    )
      .then((response) => {
        const mappedAgreementDetails = mapNewDetailsToDeprecated(
          response.data,
          t
        );
        dispatch.contractsAgreements.storeAgreementDetails(
          mappedAgreementDetails,
          agreementId
        );
        return mappedAgreementDetails;
      })
      .catch((error) => error);
  },

  async getAllContracts(): Promise<Contracts | undefined> {
    return API.get<undefined, ResponseData<Contracts>>(endpoint)
      .then((response) => {
        try {
          const mappedAgreements = response.data.contracts.map(
            mapContractToAgreement
          );
          dispatch.contractsAgreements.storeAllAgreements(
            mappedAgreements,
            response.data.totalDebtAmountOnAllContractsByCurrency
          );
          dispatch.contracts.storeAllContracts(response.data);
        } catch (mappingError) {
          console.error(
            'Mapping contracts to agreements failed:',
            mappingError
          );
        }
        // for future rebuild
        // dispatch.contracts.storeAllContracts(setData);
        return response.data;
      })
      .catch((error) => error);
  },

  async getContractPaymentDetails(
    contractId: number
  ): Promise<PaymentDetails | undefined> {
    return API.get<undefined, ResponseData<ContractPaymentDetails>>(
      `${endpoint}/${contractId}/payments/details`
    )
      .then((response) => mapPaymentsDetails(response.data))
      .catch((error) => error);
  }
});

export default effects;
